function CircleSVG(props) {
  return (
    <svg
      className="shape-2 d-none d-sm-block"
      style={{fill: props.data.startColor}}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="50" cy="50" r="50"></circle>
    </svg>
  );
}

export default CircleSVG;